import {Drawer, Form, Card, Row, Col, Button, notification} from 'antd'
import React from 'react';
import { connect } from 'react-redux';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import _ from 'lodash';
import async, { forEach } from 'async';
import Request, {API_URL, LAPI_URL} from '../../request';
@Form.create()
class InvoiceUploadForm extends React.Component {
    state={
        visible:true,
        invoiceType:null,
        loading:false
    }
    
    onClose = () =>{
        this.setState({visible:false, invoiceType:null})
        setTimeout(()=>{
            this.props.onClose();
        },200)
    }


    handleSubmit = (e) => {
        let {form, selectMultipleRecords} = this.props
        let {loading} = this.state
        e.preventDefault();
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)

            let data = []
            for(let key in selectMultipleRecords) {
                let obj = selectMultipleRecords[key];
                data.push(obj)
            }
            values.selectMultipleRecords = data;
            this.setState({loading:true})
            let response = await Request.uploadMultipleInvoice(values)
            this.setState({loading:false})
            if(response.success) {
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let {visible,invoiceType} = this.state
        let {form:{setFieldsValue, getFieldDecorator}} = this.props;
        const inputTypes = {
            fields:[
                {
                    label:'Invoice Type',
                    key:'invoiceType',
                    type:'select',
                    required:true,
                    options:[{id:'CP', display:'CP Invoice'}, {id:'AP', display:'AP Invoice'}],
                    onChange:v=>{
                        setFieldsValue({invoiceType:v})
                        this.setState({invoiceType:v})
                    }
                },
                {
                    label:`${invoiceType} Upload Invoice`,
                    key:`${invoiceType && invoiceType!= null?invoiceType.toLowerCase():null}UploadInvoice`,
                    type:'file',
                    required:true,
                    hidden:invoiceType == null?true:false
                },
                {
                    label:`${invoiceType} Invoice Number`,
                    key:invoiceType === "AP"?"apInvoiceNumber":"invoiceGeneratedNumber",
                    type:'text',
                    required:true,
                    hidden:invoiceType == null?true:false
                },
                {
                    label: `${invoiceType} Receipt Invoice`,
                    key: `${invoiceType && invoiceType!= null?invoiceType.toLowerCase():null}ReceiptUpload`,
                    type: 'file',
                    required:invoiceType === "AP"?true:false,
                    hidden:invoiceType !== "AP"?true:false
                }
            ]
        }
        return (
            <Drawer title={
                <div>
                    <React.Fragment>
                        Upload Invoice
                    </React.Fragment>
                </div>
            }
            placement="right"
            closable={true}
            onClose={this.onClose}
            width={800}
            visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} inputSchema={inputTypes} apiurl={LAPI_URL} />
                        <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.state.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceUploadForm)